import { Coords } from "google-map-react"

export const getUserLocation = (): Coords => {
    return {
        lat: 32.085300,
        lng: 34.781769
    }
}